var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line import/no-duplicates
import NewProductBadgeSVG from '@svgs/funnel/BookmarkBadge.svg';
// eslint-disable-next-line import/no-duplicates
import NewProductBadgeSVGUrl from '@svgs/funnel/BookmarkBadge.svg?url';
import { clsx } from 'clsx';
import { useEffect, useRef, useState } from 'react';
function NewProductBadge() {
    var _a = useState(false), isHalfwayInViewport = _a[0], setIsHalfwayInViewport = _a[1];
    var newProductBadgeRef = useRef(null);
    useEffect(function () {
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    setIsHalfwayInViewport(true);
                }
            });
        }, { rootMargin: '0px 0px -40% 0px' });
        if (newProductBadgeRef.current) {
            observer.observe(newProductBadgeRef.current);
        }
        return function () {
            if (newProductBadgeRef.current) {
                observer.unobserve(newProductBadgeRef.current);
            }
        };
    });
    return (_jsxs("div", __assign({ style: {
            clipPath: "url(".concat(NewProductBadgeSVGUrl, "#clip-path-2)"),
        }, ref: newProductBadgeRef, className: "absolute -top-[10px] -right-[10px] flex justify-center items-center overflow-hidden" }, { children: [_jsxs("div", __assign({ className: clsx('flex gap-4 absolute top-0 left-0 h-full', isHalfwayInViewport ? 'translate-x-[-200px] opacity-100' : 'translate-x-[75px] opacity-0', 'transition-transform duration-500 ease-in-out') }, { children: [_jsx("div", { className: clsx('w-16 skew-x-[-45deg] h-full bg-chew-toy-200') }), _jsx("div", { className: clsx('w-16 skew-x-[-45deg] h-full bg-chew-toy-200') })] })), _jsx(NewProductBadgeSVG, { className: "text-chew-toy" }), _jsx("span", __assign({ className: "absolute top-0 right-0 bottom-0 left-0 pl-px pb-[2px] flex justify-center items-center text-2xs-head-d font-display text-center" }, { children: "New!" }))] })));
}
export default NewProductBadge;
